import { forwardRef } from 'react';
import MuiMenu from '@mui/material/Menu';
import type { MenuProps as MuiMenuProps } from '@mui/material/Menu';
import MuiMenuItem from '@mui/material/MenuItem';
import type { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';

/** Aliases diretos do MUI: nenhuma das duas peças tem aparência própria do projeto a impor. */
export type MenuProps = MuiMenuProps;
export type MenuItemProps = MuiMenuItemProps;

// As duas peças residem no mesmo arquivo pelo mesmo motivo do Accordion e do Dialog:
// um MenuItem isolado não tem uso fora de um Menu — formam uma unidade indivisível.

/** Menu do design system: mesmo tipo/ref/estrutura de pasta dos demais átomos — ver `UserMenu`/`LanguageMenu`/`AccountSelector` (`layout/navbar/`) como usos de referência já existentes. */
export const Menu = forwardRef<HTMLDivElement, MenuProps>(function Menu(props, ref) {
  return <MuiMenu ref={ref} {...props} />;
});

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(function MenuItem(props, ref) {
  return <MuiMenuItem ref={ref} {...props} />;
});
